import createBrowserHistory from 'history/createBrowserHistory';

/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */
const history = createBrowserHistory({
  basename: 'admin'
});

export default history;
